import {object, string, ref} from "yup";

export const createPasswordSchema = object({
    password: string()
        .required("Lütfen şifreyi giriniz.")
        .min(6, "Şifreniz en az 6 karakterden oluşmalıdır."),
    retryPassword: string()
        .required("Lütfen Şifreyi tekrar giriniz.")
        .oneOf([ref('password')], "Şifreler eşleşmiyor.")
});